import { createContext, useContext, useMemo, useState } from 'react'

export interface ThriftSearch {
  name: string
  categoryId: string
}

const EMPTY: ThriftSearch = { name: '', categoryId: '' }

/** Where thrift results live. Committing a search anywhere in the vertical lands here. */
export const THRIFT_DISCOVERY_PATH = '/thrifts'

interface ThriftSearchContextValue {
  search: ThriftSearch
  setSearch: (next: ThriftSearch) => void
}

/** Shares the discovery search between the header search pill and the results grid. */
export const ThriftSearchContext = createContext<ThriftSearchContextValue>({
  search: EMPTY,
  setSearch: () => {},
})

export function useThriftSearch(): ThriftSearchContextValue {
  return useContext(ThriftSearchContext)
}

/**
 * The search state, owned by the route layout that spans every thrift surface
 * (see `ThriftSearchLayout`) rather than by a page.
 *
 * Held above the routes so it survives opening an item and coming back, and so the
 * pill in the header of an item's detail page — a page with no results of its own —
 * edits the same query the grid will read when it commits.
 */
export function useThriftSearchState(): ThriftSearchContextValue {
  const [search, setSearch] = useState<ThriftSearch>(EMPTY)
  return useMemo(() => ({ search, setSearch }), [search])
}
